<script lang="ts">
  // Container das telas de auth — alterna entre Login / Register via tabs.
  import LoginForm from './LoginForm.svelte';
  import RegisterForm from './RegisterForm.svelte';

  type Tab = 'login' | 'register';
  let active: Tab = $state('login');
</script>

<section class="auth-card">
  <div class="hero">
    <img class="logo" src="/images/logo-torneios.webp" alt="Torneios Truco" />
    <p class="tagline">entre pra jogar os campeonatos</p>
  </div>

  <div class="tabs" role="tablist">
    <button
      class="tab"
      class:active={active === 'login'}
      role="tab"
      aria-selected={active === 'login'}
      onclick={() => (active = 'login')}
    >
      Entrar
    </button>
    <button
      class="tab"
      class:active={active === 'register'}
      role="tab"
      aria-selected={active === 'register'}
      onclick={() => (active = 'register')}
    >
      Cadastrar
    </button>
  </div>

  <div class="content">
    {#if active === 'login'}
      <LoginForm />
    {:else}
      <RegisterForm onSuccess={() => (active = 'login')} />
    {/if}
  </div>
</section>

<style>
  .auth-card {
    width: 100%;
    max-width: 380px;
    padding: 20px 22px 24px;
    background: linear-gradient(180deg, #faf5ec 0%, #fff 60%, #f0e7d5 100%);
    border: 4px solid #1565C0;
    outline: 2px solid #ffb300;
    outline-offset: -3px;
    border-radius: 16px;
    box-shadow: 0 6px 0 #0D47A1, 0 18px 44px rgba(0, 0, 0, 0.4);
  }
  .hero {
    text-align: center;
    margin-bottom: 18px;
  }
  .logo {
    height: 72px;
    width: auto;
    object-fit: contain;
    filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.25));
  }
  .tagline {
    margin: 6px 0 0;
    color: #1976D2;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    background: rgba(21, 101, 192, 0.1);
    border: 2px solid #1565C0;
    padding: 4px;
    border-radius: 10px;
    margin-bottom: 18px;
  }
  .tab {
    padding: 9px;
    border: none;
    background: transparent;
    color: #1976D2;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.5px;
    border-radius: 7px;
    cursor: pointer;
    transition: background .12s, color .12s;
  }
  .tab:hover { background: rgba(21, 101, 192, 0.12); }
  .tab.active {
    background: linear-gradient(180deg, #1976D2, #1565C0);
    color: #fff;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    box-shadow: 0 2px 0 #0D47A1;
  }

  .content { padding: 4px 0 0; }
</style>
